import {environment} from "../../environments/environment";

export const AppConfig: any = {
  apiUrl: environment.apiUrl
};
